import { render, staticRenderFns } from "./IconDeleteFile.vue?vue&type=template&id=77978010&"
import script from "./IconDeleteFile.vue?vue&type=script&lang=js&"
export * from "./IconDeleteFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports